import React, { useState } from 'react';
import BusinessProfile from './BusinessProfile';
import Branding from './Branding';
import NotificationSettings from './NotificationSettings';
import InvoiceDefaults from './InvoiceDefaults';
import KeyDateDefaults from './KeyDateDefaults';
import Team from './Team';
import PortalLinks from './PortalLinks';
import DataManagement from './DataManagement';
import DangerZone from './DangerZone';
import PaymentsSettings from './PaymentsSettings';
import PricingCatalog from './PricingCatalog';
import AiSettings from './AiSettings';
import EngineerLoginManagement from '../engineers/EngineerLoginManagement';

const screens = { Business: BusinessProfile, Branding, Notifications: NotificationSettings, Invoices: InvoiceDefaults, 'Key dates': KeyDateDefaults, Payments: PaymentsSettings, 'Price catalogue': PricingCatalog, AI: AiSettings, Team, 'Portal links': PortalLinks, 'Engineer access': EngineerLoginManagement, Data: DataManagement, 'Danger zone': DangerZone };

export default function SettingsLayout() {
  const [active, setActive] = useState('Business');
  const Screen = screens[active];
  return <div className="standalone-page"><header className="simple-header"><div><span className="eyebrow">Workspace</span><h1>Settings</h1></div></header><div className="settings-layout"><nav className="settings-tabs">{Object.keys(screens).map((name) => <button className={active === name ? 'active' : ''} onClick={() => setActive(name)} key={name}>{name}</button>)}</nav><Screen /></div></div>;
}
